import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../../services/api";

const PrivateRoute = ({ children, page }) => {
  const [backEndPermission, setBackEndPermission] = useState(null);

  const getUserDetails = () => {
    const mail = localStorage.getItem("@USER_MAIL");
    const permission = localStorage.getItem("@USER_PERMISSION");

    if (!mail) {
      return <Navigate to="/" />;
    }

    if (permission === "Administrativo") {
      return children;
    } else if (permission === "Cliente") {
      if (page === "dashboard" || page === "inventary") {
        return children;
      } else {
        localStorage.removeItem("@USER_MAIL");
        window.location.href = "/";
      }
    }
  };

  return getUserDetails();
};

export default PrivateRoute;
